
export const SET_LOGIN_INFO = "SET_LOGIN_INFO";
export const SET_PLACE_INFO = "SET_PLACE_INFO";
export const SET_EDITED_PROFILE = "SET_EDITED_PROFILE";

export const SET_PAYMENT_TYPE = "SET_PAYMENT_TYPE";